export default __webpack_public_path__ + "static/media/frame_30_delay-0.05s.b13879cb.gif";